import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';
import { useStore } from '@common/helpers/storeProvider';
import InProductSettings from '../../InProductSettings';
import { CategorizedContentStoreContext } from '../../constants';
import { adminAccessProductsPropTypes } from '../../propTypes';
import { buttonStyle, headerWrapperStyle } from './styles';

const Header = ({
  adminAccessProducts,
  onCancelButtonClick,
  onEditButtonClick,
  onSaveButtonClick,
  showEditButton,
  showInProductSettings,
}) => {
  const { T } = useLocale(({ locale }) =>
    require(`../../../i18n/${locale}.json`)
  );
  const { store } = useStore(CategorizedContentStoreContext);
  const {
    ui: {
      isEditing,
      missingRequiredField,
      projectDataChanged,
      showProjectValueError,
    },
  } = store;
  const saveDisabled =
    missingRequiredField || !projectDataChanged || showProjectValueError;

  const renderButtons = () => {
    if (isEditing) {
      return (
        <>
          <Button
            id="cancelButton"
            onClick={onCancelButtonClick}
            size={Button.SIZES.MEDIUM}
            style={buttonStyle}
            variant={Button.VARIANTS.SECONDARY}
          >
            {T.translate('PROJECT_CANCEL_BUTTON')}
          </Button>
          <Button
            disabled={saveDisabled}
            id="saveButton"
            onClick={onSaveButtonClick}
            size={Button.SIZES.MEDIUM}
            style={buttonStyle}
            variant={Button.VARIANTS.PRIMARY}
          >
            {T.translate('PROJECT_SAVE_BUTTON')}
          </Button>
        </>
      );
    }

    return (
      <Button
        style={buttonStyle}
        id="editButton"
        size={Button.SIZES.MEDIUM}
        variant={Button.VARIANTS.PRIMARY}
        onClick={onEditButtonClick}
      >
        {T.translate('PROJECT_EDIT_BUTTON')}
      </Button>
    );
  };

  if (!showEditButton && !showInProductSettings) {
    return null;
  }

  return (
    <div css={headerWrapperStyle}>
      {showEditButton && renderButtons()}
      {showInProductSettings && (
        <InProductSettings adminAccessProducts={adminAccessProducts} />
      )}
    </div>
  );
};

Header.propTypes = {
  adminAccessProducts: adminAccessProductsPropTypes,
  onEditButtonClick: PropTypes.func,
  onCancelButtonClick: PropTypes.func,
  onSaveButtonClick: PropTypes.func,
  showEditButton: PropTypes.bool,
  showInProductSettings: PropTypes.bool,
};

export default Header;
